import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Avatar } from '../avatar/avatar';
import { Badge } from '../badge/badge';

const SKELETON_ROW_INDEXES = [0, 1, 2];
const FALLBACK_ROLE_LABEL_KEY = 'persons.teams.roles.other';

const ROLE_LABEL_KEYS = new Map<string, string>([
  ['member', 'persons.teams.roles.member'],
  ['lead', 'persons.teams.roles.lead'],
  ['coordinator', 'persons.teams.roles.coordinator'],
  ['other', 'persons.teams.roles.other'],
]);

export interface TeamMemberAssignment {
  personId: string;
  role: string;
}

export interface TeamMemberPreviewRow {
  personId: string;
  displayName: string;
  avatarUrl: string | null;
  role: string;
}

@Component({
  selector: 'zag-team-members-preview',
  templateUrl: './team-members-preview.component.html',
  styleUrl: './team-members-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, Avatar, Badge],
})
export class TeamMembersPreviewComponent {
  readonly assignments = input<TeamMemberAssignment[]>([]);
  readonly loading = input(false);
  readonly loadError = input(false);
  readonly labels = input<Map<string, string> | null>(null);
  readonly avatarUrls = input<Map<string, string | null> | null>(null);

  protected readonly skeletonRows = SKELETON_ROW_INDEXES;

  protected readonly rows = computed<TeamMemberPreviewRow[]>(() => {
    const labels = this.labels();
    const avatarUrls = this.avatarUrls();
    return this.assignments().map(assignment => ({
      personId: assignment.personId,
      displayName: labels?.get(assignment.personId) ?? assignment.personId,
      avatarUrl: avatarUrls?.get(assignment.personId) ?? null,
      role: assignment.role,
    }));
  });

  protected roleLabelKey(role: string): string {
    return ROLE_LABEL_KEYS.get(role) ?? FALLBACK_ROLE_LABEL_KEY;
  }
}
